<template lang="pug">
  table.table.table-bordered.table_document
    tr
      td Дата явки
      td
        span(v-if='data.body.content.appear_date') {{data.body.content.appear_date | date}}
        span(v-if='!data.body.content.appear_date') —
    tr
      td Жалобы
      td {{formatAnswer(data.body.content.complaints, 2)}}
    tr
      td Привычные (базисные) цифры АД
      td {{formatAnswer(data.body.content.usual_pressure, 2)}}
    tr
      td Достижение целевого АД
      td {{formatAnswer(data.body.content.target_pressure, 2)}}
    tr
      td Осложнения с момента последней явки
      td {{formatAnswer(data.body.content.complications, 2)}}
    tr
      td Давность артериальной гипертензии
      td {{formatAnswer(data.body.content.arterial_hypertension_prescription, 2)}}
    tr
      td Наследственность по ГБ
      td {{formatAnswer(data.body.content.hypertensive_heredity, 2)}}
    tr
      td Наследственность по ранним сосудистым катастрофам
      td {{formatAnswer(data.body.content.vascular_heredity, 2)}}
    tr
      td Курение
      td {{formatAnswer(data.body.content.smoking, 2)}}
    tr
      td Объем талии
      td {{formatAnswer(data.body.content.waist_volume, 2)}}
    tr
      td Гиперхолестеринемия
      td {{formatAnswer(data.body.content.hypercholesterolemia, 2)}}
    tr
      td Дислипидемия
      td {{formatAnswer(data.body.content.dyslipidemia, 2)}}
    tr
      td Гипертриглицеридемия
      td {{formatAnswer(data.body.content.hypertriglyceridemia, 2)}}
    tr
      td Полиморфизм и ГБ
      td {{formatAnswer(data.body.content.polymorphism, 2)}}
    tr
      td Сахарный диабет
      td {{formatAnswer(data.body.content.diabetes, 2)}}
    tr
      td Данные лабораторных исследований
      td(v-if="data.body.content.laboratory_data_first")
        table.table.table-bordered.table_document(v-if="data.body.content.laboratory_data_first")
          tr
            td Холестерин
            td {{formatAnswer(data.body.content.laboratory_data_first.cholesterol_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.cholesterol_date") &nbsp;({{data.body.content.laboratory_data_first.cholesterol_date | date}})
          tr
            td HDL-холестерин
            td {{formatAnswer(data.body.content.laboratory_data_first.HDL_cholesterol_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.HDL_cholesterol_date") &nbsp;({{data.body.content.laboratory_data_first.HDL_cholesterol_date | date}})
          tr
            td LDL-холестерин
            td {{formatAnswer(data.body.content.laboratory_data_first.LDL_cholesterol_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.LDL_cholesterol_date") &nbsp;({{data.body.content.laboratory_data_first.LDL_cholesterol_date | date}})
          tr
            td Коэффициент атерогенности
            td {{formatAnswer(data.body.content.laboratory_data_first.atherogenicity_coefficient_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.atherogenicity_coefficient_date") &nbsp;({{data.body.content.laboratory_data_first.atherogenicity_coefficient_date | date}})
          tr
            td Триглицериды
            td {{formatAnswer(data.body.content.laboratory_data_first.triglyceride_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.triglyceride_date") &nbsp;({{data.body.content.laboratory_data_first.triglyceride_date | date}})
          tr
            td Мочевая кислота
            td {{formatAnswer(data.body.content.laboratory_data_first.uric_acid_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.uric_acid_date") &nbsp;({{data.body.content.laboratory_data_first.uric_acid_date | date}})
          tr
            td Высокоспецифичный СРБ
            td {{formatAnswer(data.body.content.laboratory_data_first.reactive_protein_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.reactive_protein_date") &nbsp;({{data.body.content.laboratory_data_first.reactive_protein_date | date}})

          tr
            td Глюкоза
            td {{formatAnswer(data.body.content.laboratory_data_first.glucose_value, 2)}}
              span(v-if="data.body.content.laboratory_data_first.glucose_date") &nbsp;({{data.body.content.laboratory_data_first.glucose_date | date}})
      td(v-if="!data.body.content.laboratory_data_first") —
    tr
      td Ангиопатия (ангиоспазм) сетчатки
      td {{formatAnswer(data.body.content.retinal_angiopathy, 2)}}
        span(v-if="data.body.content.retinal_angiopathy_date") &nbsp;({{data.body.content.retinal_angiopathy_date | date}})
    tr
      td Протеинурия
      td {{formatAnswer(data.body.content.proteinuria, 2)}}
    tr
      td Микроальбуминурия
      td {{formatAnswer(data.body.content.microalbuminuria, 2)}}
    tr
      td Гиперкреатининемия
      td {{formatAnswer(data.body.content.hypercreatininemia, 2)}}
    tr
      td Гипертрофия ЛЖ
      td {{formatAnswer(data.body.content.hypertrophy, 2)}}
    tr
      td Изменения сосудов
      td {{formatAnswer(data.body.content.vessel_changes, 2)}}
    tr
      td Атеросклероз сосудов
      td {{formatAnswer(data.body.content.vascular_atherosclerosis, 2)}}
    tr
      td Данные лабораторных исследований
      td(v-if="data.body.content.laboratory_data_second")
        table.table.table-bordered.table_document(v-if="data.body.content.laboratory_data_second")
          tr
            td Белок в моче значение
            td {{formatAnswer(data.body.content.laboratory_data_second.urine_protein_value, 2)}}
              span(v-if="data.body.content.laboratory_data_second.urine_protein_date") &nbsp;({{data.body.content.laboratory_data_second.urine_protein_date | date}})
          tr
            td Микроальбуминурия
            td {{formatAnswer(data.body.content.laboratory_data_second.microalbumin_value, 2)}}
              span(v-if="data.body.content.laboratory_data_second.microalbumin_date") &nbsp;({{data.body.content.laboratory_data_second.microalbumin_date | date}})
          tr
            td Креатинин крови
            td {{formatAnswer(data.body.content.laboratory_data_second.blood_creatinine_value, 2)}}
              span(v-if="data.body.content.laboratory_data_second.blood_creatinine_date") &nbsp;({{data.body.content.laboratory_data_second.blood_creatinine_date | date}})
          tr
            td Калий крови
            td {{formatAnswer(data.body.content.laboratory_data_second.blood_potassium_value, 2)}}
              span(v-if="data.body.content.laboratory_data_second.blood_potassium_date") &nbsp;({{data.body.content.laboratory_data_second.blood_potassium_date | date}})
          tr
            td Натрий крови
            td {{formatAnswer(data.body.content.laboratory_data_second.blood_sodium_value, 2)}}
              span(v-if="data.body.content.laboratory_data_second.blood_sodium_date") &nbsp;({{data.body.content.laboratory_data_second.blood_sodium_date | date}})
          tr
            td Кальций крови
            td {{formatAnswer(data.body.content.laboratory_data_second.blood_calcium_value, 2)}}
              span(v-if="data.body.content.laboratory_data_second.blood_calcium_date") &nbsp;({{data.body.content.laboratory_data_second.blood_calcium_date | date}})
      td(v-if="!data.body.content.laboratory_data_second") —
    tr
      td ОНМК
      td {{formatAnswer(data.body.content.onmk, 2)}}
    tr
      td ИБС
      td {{formatAnswer(data.body.content.chd, 2)}}
    tr
      td ХСН
      td {{formatAnswer(data.body.content.chf, 2)}}
    tr
      td Диабетическая нефропатия
      td {{formatAnswer(data.body.content.nephropathy, 2)}}
    tr
      td Почечная недостаточность
      td {{formatAnswer(data.body.content.renal_failure, 2)}}
    tr
      td Облитерирующий атеросклероз сосудов
      td {{formatAnswer(data.body.content.obliterating_vascular_atherosclerosis, 2)}}
    tr
      td Ретинопатия
      td {{formatAnswer(data.body.content.retinopathy, 2)}}
    tr
      td MDRD
      td {{formatAnswer(data.body.content.mdrd, 2)}}
    tr
      td Пульс
      td {{formatAnswer(data.body.content.pulse, 2)}}
    tr
      td Тоны сердца
      td {{formatAnswer(data.body.content.heart_tones, 2)}}
    tr
      td Шумы на сосудах
      td {{formatAnswer(data.body.content.vessels_noises, 2)}}
    tr
      td Диагноз
      td {{formatAnswer(data.body.content.diagnosis, 2)}}
    tr
      td Число установленных факторов риска
      td {{formatAnswer(data.body.content.fr_count, 2)}}
    tr
      td Полнота заполнения карты
      td {{formatAnswer(data.body.content.card_filling, 2)}}
    tr
      td Осложнение основного диагноза
      td {{formatAnswer(data.body.content.diagnosis_complication, 2)}}
    tr
      td Сопутствующий диагноз
      td {{formatAnswer(data.body.content.concomitant_diagnosis, 2)}}
    tr
      td Терапия Медикаментозная
      td {{formatAnswer(data.body.content.drug_therapy, 2)}}
    tr
      td Терапия Немедикаментозная
      td {{formatAnswer(data.body.content.non_drug_therapy, 2)}}
</template>
<script>
export default {
  props: ['data'],

  methods: {
    formatAnswer (fact, type) {
      switch (type) {
        case 1:
          return fact !== undefined ? (fact ? 'Да' : 'Нет') : '—'
        case 2:
          return fact || '—'
        case 3:
          return fact ? fact.name : '—'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/DocumentStyles.sass"
</style>
